export const getUserPaymentMethod = (state) => state.payment.stripe.paymentMethod;
